import React from 'react';
import { get } from 'lodash';
import { withRouter } from 'react-router-dom';
import searchQuery from 'query-string';
import * as backRoute from 'utils/backRoute';

// local dependencies
import { MemberDetailsArEntityWidgetService } from 'services/memberDetailsAREntityWidget';
import { memberDetailsArEntityWidget as MemberDetailsArEntityWidgetView } from 'ui/views/widgets/memberDetailsAREntityWidget';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { DASHBOARD_SUB_ROUTES } from 'constants/route-paths';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { MemberDetailsArEntityWidget } from 'ui/containers/MemberDetailsAREntityWidget';
 *
 * // render
 * <MemberDetailsArEntityWidget propName='propValue'/>
 */
export class _MemberDetailsArEntityWidget extends React.Component {

    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        this.state = {
            isFetching: true,
            networkState: undefined,
            componentData: undefined
        };

        this.handleActionClick = this.handleActionClick.bind( this );

        // member AR instance
        this.memberDetailsArEntityWidgetService = new MemberDetailsArEntityWidgetService();

        // start data fetch
        this.memberDetailsArEntityWidgetData();
    }

    async memberDetailsArEntityWidgetData() {
        log.debug( 'MemberDetailsPrescriptionsEntityWidget.memberDetailsClaimsEntityWidgetData()' );

        // cancel ongoing request
        this.memberDetailsArEntityWidgetService.cancel();

        try {
            const { status, data } = await this.memberDetailsArEntityWidgetService.fetchData( {
                url: this.props.widget.url,
                data: this.props.requestPayload,
            } );

            // check if response status was success
            if ( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
                this.setState( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
                } );
            } else {
                this.setState( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                    componentData: data
                } );
            }
        } catch ( e ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE,
            } );
        }
    }

    /**
     * @desc Action handler for column action and group action
     */
    handleActionClick( { type = 'column', value = {}, item = {} } = {} ) {
        log.debug( 'MemberDetailsAREntityWidget.handleActionClick()' );

        // get member id
        const memberId = get( this.props, 'requestPayload.context.memberId', null );
        const patientId = get( this.props, 'requestPayload.context.patientId', null );

        // prepare back-route state payload
        const backRouteState = backRoute.encode( {
            pathname: this.props.location.pathname,
            payload: {
                entitiesActiveTabIndex: this.props.tabIndex,
                memberId: memberId,
                patientId: patientId
            },
        } );

        if ( 'column' === type && 'orderNumber' === value.name ) {
            this.props.history.push( {
                pathname: DASHBOARD_SUB_ROUTES.ORDER_DETAIL,
                state: { ...backRouteState, memberId: memberId, patientId: patientId },
                search: searchQuery.stringify( {
                    orderId: item.values.orderId,
                } )
            } );
        }

    }

    /**
     * @desc When component unmounts, cleanup resouces.
     */
    componentWillUnmount() {
        log.debug( 'MemberDetailsAREntityWidget.componentWillUnmount()' );

        this.memberDetailsArEntityWidgetService.cancel(); // cancel ongoing request

    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <MemberDetailsArEntityWidgetView
                isFetching={this.state.isFetching}
                networkState={this.state.networkStatus}
                componentData={get( this.state, 'componentData', {} )}
                requestPayload={this.props.requestPayload}
                onActionClick={this.handleActionClick}
            />
        );
    }
}

// set display name
_MemberDetailsArEntityWidget.displayName = '_MemberDetailsArEntityWidget';

// set default props
_MemberDetailsArEntityWidget.defaultProps = {};

// prop types
_MemberDetailsArEntityWidget.propTypes = {};

export const MemberDetailsArEntityWidget = withRouter( _MemberDetailsArEntityWidget );
